import dynamic from 'next/dynamic';

import { ShareButtonsPreloader } from './Preloader';

export const DynamicShareButtons = dynamic(() => import('./buttons'), {
  ssr: false,
  loading: ({ isLoading }) => <>{isLoading ? <ShareButtonsPreloader /> : null}</>,
});
